/* eslint-disable react/jsx-curly-newline */
import React from 'react';

import OSM from 'ol/source/OSM';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { connect, useDispatch } from 'react-redux';

import Icons from 'consts/icons';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { addAlert } from 'store/actions/alert/alerts';
import { authPatchRequestWithParam } from 'helpers/apiRequests';
import { basicUavoStyle } from 'components/uavos/utils/common';
import { getLayerByName } from 'utils/map/layers';
import { hasArrayElements } from 'utils/main';
import { MAP_TILES, WEATHER_TILES } from 'consts/mapConfig';
import { setWeatherLayer } from 'store/actions/map/weatherLayer';
import { tileServerUrl } from 'consts/config';

import { FiltersDetailsUseStyles } from 'components/dashboard/filters/FiltersDetailsUseStyles';
import { returnWeatherLayer } from './mapUtils';
import { useStyles } from './TilesChooseUseStyles';

const TilesChoose = props => {
  const { map, mappingUavos, language } = props;

  const classes = useStyles();
  const classesFilters = FiltersDetailsUseStyles();

  const dispatch = useDispatch();
  const [selectedWeatherOption, setSelectedWeatherOption] = React.useState(
    'none'
  );
  const [selectedMapOption, setSelectedMapOption] = React.useState(
    UserSessionDataHandler.getFromUserSettingsObjectInStore(
      UserSessionDataHandler.defaultTiles
    )
  );

  const clickHandlerMap = option => {
    setSelectedMapOption(option);
    updateUserMapChoice(option);
    changeUavosIconColor();
    saveToDb(option);
  };

  const clickHandlerWeather = option => {
    updateUserWeatherChoice(option);
    dispatch(setWeatherLayer(option));
    setSelectedWeatherOption(option);
  };

  const updateUserWeatherChoice = option => {
    updateWeatherSessionData(option);
    if (!getLayerByName(map, 'weatherLayer')) {
      map.addLayer(returnWeatherLayer());
      getLayerByName(map, 'weatherLayer').setSource(
        new OSM({
          url: tileServerUrl(option),
        })
      );
    } else {
      getLayerByName(map, 'weatherLayer').setSource(
        new OSM({
          url: tileServerUrl(option),
        })
      );
    }
  };

  const updateWeatherSessionData = option => {
    UserSessionDataHandler.saveToUserSettingsObjectInStorage(
      UserSessionDataHandler.defaultWeather,
      option
    );
  };

  const updateUserMapChoice = option => {
    UserSessionDataHandler.saveToUserSettingsObjectInStorage(
      UserSessionDataHandler.defaultTiles,
      option
    );
    getLayerByName(map, 'tileLayer').setSource(
      new OSM({
        url: tileServerUrl(option),
      })
    );
  };

  const changeUavosIconColor = () => {
    const uavos = map
      .getLayers()
      .getArray()
      .find(layer => layer.getProperties().layerName === 'uavosLayer')
      ?.getSource()
      ?.getFeatures();
    if (!uavos && !hasArrayElements(uavos)) return;
    for (const uavo of uavos) {
      uavo.setStyle(basicUavoStyle(uavo.getProperties().data, mappingUavos));
    }
  };

  const returnIcon = weatherParam => {
    switch (weatherParam) {
      case WEATHER_TILES.temperature:
        return <Icons.Weather.Temperature className={classes.weatherIcon} />;
      case WEATHER_TILES.pressure:
        return <Icons.Misc.Schedule className={classes.weatherIcon} />;
      case WEATHER_TILES.wind:
        return <Icons.Weather.Wind className={classes.weatherIcon} />;
      case WEATHER_TILES.clouds:
        return <Icons.Weather.Cloud className={classes.weatherIcon} />;
      case WEATHER_TILES.precipitation:
        return <Icons.Weather.Rain className={classes.weatherIcon} />;
      default:
        return <span>?</span>;
    }
  };

  const hideWeatherMap = () => {
    setSelectedWeatherOption('none');
    updateWeatherSessionData('none');
    dispatch(setWeatherLayer(null));
    map.removeLayer(getLayerByName(map, 'weatherLayer'));
  };

  const saveToDb = option => {
    const configData = UserSessionDataHandler.getUserConfig();
    const updatedConfigData = {
      ...configData,
      tiles: option,
    };
    authPatchRequestWithParam(
      'setUserConfiguration',
      UserSessionDataHandler.getUserDataObject().uid,
      { configuration: updatedConfigData }
    ).then(result => {
      if (result.status !== 200)
        dispatch(
          addAlert({
            title: language.alerts[result.data.code].title_,
            desc: language.alerts[result.data.code].desc_,
            type: 'error',
          })
        );
    });
  };

  return (
    <div>
      <div>
        <div className={`${classesFilters.FiltersDetails}__table__details`}>
          {language.roadMap.type_}
        </div>
        <Tooltip title={language.roadMap.light}>
          <div
            className={`${classes.TilesChoose}__option ${
              classes.TilesChoose
            }__option__light--background-image ${
              selectedMapOption === MAP_TILES.mbLight ? classes.TilesChoose : ''
            }__option--border`}
            onClick={() => clickHandlerMap(MAP_TILES.mbLight)}
            onKeyPress={() => clickHandlerMap(MAP_TILES.mbLight)}
            role="button"
            label=" "
            tabIndex="0"
          ></div>
        </Tooltip>
        <Tooltip title={language.roadMap.outdoor}>
          <div
            className={`${classes.TilesChoose}__option ${
              classes.TilesChoose
            }__option__outdoor ${
              classes.TilesChoose
            }__option__outdoor--background-image ${
              selectedMapOption === MAP_TILES.mbOutdoors
                ? classes.TilesChoose
                : ''
            }__option--border`}
            onClick={() => clickHandlerMap(MAP_TILES.mbOutdoors)}
            onKeyPress={() => clickHandlerMap(MAP_TILES.mbOutdoors)}
            role="button"
            label=" "
            tabIndex="0"
          ></div>
        </Tooltip>
        <Tooltip title={language.roadMap.dark}>
          <div
            className={`${classes.TilesChoose}__option ${
              classes.TilesChoose
            }__option__dark--background-image ${
              selectedMapOption === MAP_TILES.mbDark ? classes.TilesChoose : ''
            }__option--border`}
            onClick={() => clickHandlerMap(MAP_TILES.mbDark)}
            onKeyPress={() => clickHandlerMap(MAP_TILES.mbDark)}
            role="button"
            label=" "
            tabIndex="0"
          ></div>
        </Tooltip>
        <Tooltip title={language.roadMap.street}>
          <div
            className={`${classes.TilesChoose}__option ${
              classes.TilesChoose
            }__option__streets--background-image ${
              selectedMapOption === MAP_TILES.mbStreets
                ? classes.TilesChoose
                : ''
            }__option--border`}
            onClick={() => clickHandlerMap(MAP_TILES.mbStreets)}
            onKeyPress={() => clickHandlerMap(MAP_TILES.mbStreets)}
            role="button"
            label=" "
            tabIndex="0"
          ></div>
        </Tooltip>
        <Tooltip title={language.roadMap.satellite}>
          <div
            className={`${classes.TilesChoose}__option ${
              classes.TilesChoose
            }__option__satellite--background-image ${
              selectedMapOption === MAP_TILES.mbSatellite ? classes.border : ''
            }`}
            onClick={() => clickHandlerMap(MAP_TILES.mbSatellite)}
            onKeyPress={() => clickHandlerMap(MAP_TILES.mbSatellite)}
            role="button"
            label=" "
            tabIndex="0"
          ></div>
        </Tooltip>
        <Tooltip title={language.roadMap.osm}>
          <div
            className={`${classes.TilesChoose}__option ${
              classes.TilesChoose
            }__option__osm--background-image ${
              selectedMapOption === MAP_TILES.osm ? classes.TilesChoose : ''
            }__option--border`}
            onClick={() => clickHandlerMap(MAP_TILES.osm)}
            onKeyPress={() => clickHandlerMap(MAP_TILES.osm)}
            role="button"
            label=" "
            tabIndex="0"
          ></div>
        </Tooltip>
      </div>
      <div>
        <div className={`${classesFilters.FiltersDetails}__table__details`}>
          {language.map.tileConfigurator.expandMaps_}
        </div>
        <div className={`${classes.TilesChoose}__option__weather`}>
          {Object.values(WEATHER_TILES).map(weatherParam => (
            <Tooltip
              key={weatherParam}
              title={language.map.tileConfigurator[`${weatherParam}_`]}
            >
              <div
                className={`${classes.TilesChoose}__option ${
                  classes.TilesChoose
                }__option__weather ${
                  selectedWeatherOption === WEATHER_TILES[weatherParam]
                    ? classes.TilesChoose
                    : ''
                }__option--border`}
                onClick={() => clickHandlerWeather(WEATHER_TILES[weatherParam])}
                onKeyPress={() =>
                  clickHandlerWeather(WEATHER_TILES[weatherParam])
                }
                role="button"
                label=" "
                tabIndex="0"
              >
                {returnIcon(weatherParam)}
              </div>
            </Tooltip>
          ))}
          <Tooltip title={language.map.tileConfigurator.removeWeatherLayer_}>
            <div
              className={`${classes.TilesChoose}__option ${
                classes.TilesChoose
              }__option__weather ${
                selectedWeatherOption === 'none' ? classes.TilesChoose : ''
              }__option--border`}
              onClick={() => hideWeatherMap()}
              onKeyPress={() => hideWeatherMap()}
              role="button"
              label=" "
              tabIndex="0"
            >
              <Icons.Actions.Close
                className={`${classes.TilesChoose}__option__weather__icon`}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

TilesChoose.propTypes = {
  map: PropTypes.object.isRequired,
  mappingUavos: PropTypes.object.isRequired,
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  map: state.map,
  mappingUavos: state.mappingUavos,
  language: state.language,
});

export default connect(mapStateToProps)(TilesChoose);
